import { useContext } from 'react';
import DialogContext from '../../../contexts/DialogContext';
import styles from './DialogContainer.module.css';

export const DialogContainer = () => {
    const { dialogs } = useContext(DialogContext);

    return (
        <>
            {dialogs.length > 0 && <div className={styles.dialogBackdrop} />}
            {dialogs.map(elem => {
                return (
                    <div
                        key={elem.key}
                        className={styles.dialogContainer}
                    >
                        {{
                            ...elem.dialog,
                            props: {
                                ...elem.dialog.props,
                                dialogKey: elem.key,
                            }
                        }}
                    </div>
                );
            })}
        </>
    );
}
